import { useContext } from "react";
import { UIComponentsContext } from "./UIComponentsContext";

export const useUIComponents = () => {
  const context = useContext(UIComponentsContext);
  if (!context) {
    throw new Error("useUIComponents must be used within UIComponentsProvider");
  }
  return context;
};
